var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCircleFilledCheck = function SvgIconCircleFilledCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#01F6C1",
    d: "M9 1.125a7.875 7.875 0 1 1 0 15.75 7.875 7.875 0 0 1 0-15.75m5.258 4.401a.944.944 0 0 0-1.335 0l-5.115 5.116L5.36 8.195A.943.943 0 1 0 4.026 9.53l3.115 3.115a.943.943 0 0 0 1.334 0l5.783-5.784a.944.944 0 0 0 0-1.334"
  })));
};
export default SvgIconCircleFilledCheck;